import { A } from '@ember/array';
import { computed, set } from '@ember/object';
export default function isEvery(collectionProperty, property, ...value) {
  const collectionPropertyOverride = `_isEvery_${collectionProperty}`;
  return computed(`${collectionProperty}.@each.${property}`, {
    get() {
      if (this[collectionPropertyOverride] !== undefined) {
        return this[collectionPropertyOverride];
      }
      const dependentValue = this.get(collectionProperty);
      return dependentValue && A(dependentValue).isEvery(property, ...value);
    },
    set(_, value) {
      return set(this, collectionPropertyOverride, value);
    }
  });
}